import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { WebSocketService } from 'src/app/api/web-socket.service';
import { WebSocketBalanceChange } from 'src/app/models/wss';

@Injectable()
export class WebsocketBalancesService {
  private subscription: Subscription;
  private subject = new BehaviorSubject<WebSocketBalanceChange>(null);

  private connected = false;

  constructor(private wss: WebSocketService) {}

  init() {
    this.wss.connectionChanges.subscribe(() => {
      this.connect();
    });
  }

  get() {
    if (!this.connected) {
      this.connected = true;
      this.connect();
      this.init();
    }

    return this.subject;
  }

  disconnect() {
    this.connected = false;

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private connect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.wss.balances().subscribe(response => {
      this.subject.next(response);
    });
  }
}
